<template>
	<div class="columns is-vcentered">
		<div class="column py-2 is-3">
			<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
				id="level_1_select" v-model="level1Proxy" placeholder="Nivel 1" rules="required"
				@input="$emit('level1-change', $event)">
				<option v-for="value in level1Values" :key="value.name" :value="value.name">
					{{ value.name }}
				</option>
			</b-select>
		</div>
		<div class="column py-2 is-3">
			<b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
				id="level_2_select" v-model="level2Proxy" placeholder="Nivel 2"
				:key="level2SelectKey" rules="required">
				<option v-for="value in level2Options" :key="value.id" :value="value.id">
					{{ value.level_2 }}
				</option>
			</b-select>
		</div>
		<div class="column py-2 is-3">
			<b-input size="is-small" expanded class="new_cuenta new_elem_row" placeholder="Cuenta"
				v-model="level3Proxy" />
		</div>
		<div class="column py-2 is-3">
			<div class="field has-addons">
				<div class="control is-expanded mr-1">
					<b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Orden"
						v-model="orderProxy" />
				</div>
				<div class="control is-vcentered py-2">
					<button type="button" :class="[submitClass, 'ap-inline-action']"
						@click="$emit('submit')">
						{{ submitLabel }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AccountPlanInlineForm",
	props: {
		level1Values: {
			type: Array,
			default: () => [],
		},
		level2Options: {
			type: Array,
			default: () => [],
		},
		level1: {
			type: String,
			default: "",
		},
		level2: {
			type: [String, Number],
			default: "",
		},
		level3: {
			type: String,
			default: "",
		},
		order: {
			type: [String, Number],
			default: "",
		},
		submitLabel: {
			type: String,
			default: "OK",
		},
		submitClass: {
			type: String,
			default: "theme_btn_dark",
		},
		// El formulario de edición fuerza el remount del select de Nivel 2
		// cuando cambian sus opciones (:key original); el de alta no lo hacía.
		level2Remount: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		level1Proxy: {
			get() {
				return this.level1;
			},
			set(value) {
				this.$emit("update:level1", value);
			},
		},
		level2Proxy: {
			get() {
				return this.level2;
			},
			set(value) {
				this.$emit("update:level2", value);
			},
		},
		level3Proxy: {
			get() {
				return this.level3;
			},
			set(value) {
				this.$emit("update:level3", value);
			},
		},
		orderProxy: {
			get() {
				return this.order;
			},
			set(value) {
				this.$emit("update:order", value);
			},
		},
		level2SelectKey() {
			// Una key constante equivale a no tener key para un nodo único.
			return this.level2Remount ? this.level2Options.length : "level_2_select";
		},
	},
};
</script>
<style scoped lang="scss">
@use "./account_plan_buttons" as *;

.ap-inline-action {
	height: 100%;
}

// ── Inputs / selects ────────────────────────────────────────────────────
.new_elem_row {
	margin-left: 10px;
	margin-top: 5px;

	:deep(.input),
	:deep(.select select){
		border-radius: var(--ap-radius-sm);
		border-color: var(--ap-line-strong);
		font-family: var(--ap-font);
		transition: border-color 0.18s var(--ap-ease), box-shadow 0.18s var(--ap-ease);

		&:focus,
		&:focus-within {
			border-color: var(--ap-teal);
			box-shadow: 0 0 0 3px var(--ap-teal-wash);
		}
	}
}

#level_2_select {
	min-width: 100px;
}

.new_elem_row span select {
	font-weight: 600;
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

.td_level_2 {
	width: 14em;
}
</style>
